var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{staticClass:"cart-list"},_vm._l((_vm.model.items),function(i){return _c('cart-list-item',{key:_vm.cartItemKey(i),attrs:{"item":i,"owner":_vm.model,"view-only":_vm.viewOnly,"is-show-in-modal":_vm.isShowInModal}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }